import type { EntryCollection, EntrySkeletonType } from 'contentful'

export const useContentfulPreviewStore = defineStore('contentfulPreview', () => {
  const entries = ref<EntryCollection<EntrySkeletonType, undefined, string>>(undefined)

  return {
    entries,
  }
})
